import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import DropdownContext from './DropdownContext';

import stylesheet from './Dropdown.module.css';

const DropdownItem = ({ children }) => {
  const handleToggle = useContext(DropdownContext);

  return (
    <li className={stylesheet.item} onClick={handleToggle}>
      {children}
    </li>
  );
};

DropdownItem.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DropdownItem;
